(function () {
  if (window.SectionParallax) return;

  const items = [];
  let ticking = false;
  let bound = false;

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function applyParallax() {
    ticking = false;
    var isMobile = window.innerWidth <= 749;
    items.forEach(function (item) {
      const rect = item.container.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      /*
       * 旧: (-rect.top)/height だと「上端が画面上部を通過するまで」shift がほぼ0になり、
       * SPでは画像が画面のかなり上に来ないと効果が出ない。
       * FVスライダーと同様に、ビューポート中心とコンテナ中心の距離で正規化し、
       * 表示領域に入った時点から連続して効くようにする。
       */
      var vh = window.innerHeight;
      var viewportCenter = vh / 2;
      var containerCenter = rect.top + rect.height / 2;
      var normalized = clamp((containerCenter - viewportCenter) / Math.max(viewportCenter, 1), -1, 1);
      var shiftPx = normalized * item.shift;
      var img = item.layer.querySelector('.parallax__image');

      if (img) {
        /*
         * 全デバイスで img タグの transform を使って視差効果を適用する仕様に変更
         * （背景画像の background-attachment: fixed は過剰拡大のバグや余白が見えるバグがあるため）
         */
        var h = Math.max(item.layer.getBoundingClientRect().height, 1);
        var maxShiftEver = item.shift * 1.2;
        var s = 1 + (2 * maxShiftEver) / h;
        // 最低1.18倍から許容するように修正（ユーザー指定値に基づく）
        s = Math.min(Math.max(s, 1.18), 1.65);
        var t = 'translate3d(0,' + shiftPx.toFixed(2) + 'px,0) scale(' + s.toFixed(4) + ')';
        if (img.dataset.lastParallaxTransform !== t) {
          img.style.transform = t;
          img.dataset.lastParallaxTransform = t;
        }
        if (item.layer.dataset.lastParallaxPos) {
          item.layer.style.backgroundPosition = '';
          delete item.layer.dataset.lastParallaxPos;
        }
      }
    });
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(applyParallax);
  }

  function bindGlobalListeners() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick);
    document.addEventListener('shopify:section:load', requestTick);
    document.addEventListener('shopify:block:select', requestTick);
  }

  function init() {
    const roots = document.querySelectorAll('[data-section-parallax]');
    roots.forEach(function (root) {
      if (root.dataset.parallaxBound === 'true') return;
      root.dataset.parallaxBound = 'true';

      const shift = Math.max(parseInt(root.dataset.parallaxShift || '60', 10), 10);
      root.querySelectorAll('.section-parallax-layer[data-parallax-image]').forEach(function (layer) {
        const src = layer.getAttribute('data-parallax-image');
        if (src) layer.style.backgroundImage = 'url("' + src + '")';
      });

      root.querySelectorAll('.section-parallax-layer').forEach(function (layer) {
        const container = layer.closest('[data-parallax-container]') || layer.parentElement || root;
        layer.style.willChange = 'background-position';
        items.push({ layer: layer, container: container, shift: shift });
      });
    });

    bindGlobalListeners();
    requestTick();
  }

  window.SectionParallax = {
    init: init
  };
})();
